import { DAY_IN_MS } from '../constants'
import { getTodayInMs } from './getTodayInMs'

export const getYesterdayInMs = (): number => getTodayInMs() - DAY_IN_MS
